import _BaseHttpService from './baseHttp.service'

class BaseCrudService extends _BaseHttpService {
  constructor (key = null, template = null) {
    super(key)
    this.__itemTemplate = template || {}
  }

  endpoints () {
    return this.constructor._endpoints(this.__key)
  }

  create (data, ...callbacks) {
    this.constructor.post(this.endpoints().create, data, ...callbacks)
  }

  update (itemId, data, ...callbacks) {
    this.constructor.patch(this.endpoints().update.replace('{:id}', itemId), data, ...callbacks)
  }

  getList (params, ...callbacks) {
    params = params || { sort: '-id', page: 1 }
    let clean = Object.assign({}, params)
    delete clean.filter
    this.constructor.get(
      this.endpoints().list,
      {
        params: Object.assign(clean, {
          filters: JSON.stringify(params.filter)
        })
      }, ...callbacks)
  }

  drop (itemId, ...callbacks) {
    this.constructor.delete(this.endpoints().update.replace('{:id}', itemId), ...callbacks)
  }

  item (itemId, ...callbacks) {
    this.constructor.get(this.endpoints().get.replace('{:id}', itemId), {}, ...callbacks)
  }
}

export default BaseCrudService
